const ACTION_PREPEND = 'orderPlaced';
export const GET_OPD_NOTIFICATIONS = `${ACTION_PREPEND}/GET_OPD_NOTIFICATIONS`;
